import { type AiBuilderChoiceOption } from '../store';
import { AiBuilderChoiceOptionShell } from './AiBuilderChoiceOptionShell';
export const AiBuilderRadioOptionButton = ({
  onSelect,
  option,
  selected
}: {
  onSelect: () => void;
  option: AiBuilderChoiceOption;
  selected: boolean;
}) => {
  return <AiBuilderChoiceOptionShell option={option} selected={selected} onSelect={onSelect} indicator={<span aria-hidden="true" data-ai-choice-indicator="radio" className="flex size-5 flex-none items-center justify-center rounded-full border-2 border-neutral bg-default">
          {selected && <span className="size-3 rounded-full bg-primary" />}
        </span>} data-sentry-element="AiBuilderChoiceOptionShell" data-sentry-component="AiBuilderRadioOptionButton" data-sentry-source-file="AiBuilderRadioOptionButton.tsx" />;
};